import { FieldWrapper } from '@progress/kendo-react-form';
import React from 'react'; 

const CusAddBtn = (props) => {
    const {id, label,disabled} = props;
    return(
        
        <div className="row around-xs inputPair elementVisible">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <button id={id} className="box no-border-bg-white"  
                disabled={disabled}
                onClick={ e => {
                        e.preventDefault();
                        props.onClick();
                    }}>
                <span className="k-icon k-i-plus" style={{fontSize:'13px', color:'#8D8D8D'}}></span>&nbsp;
                <span style={{fontSize:'14px', color:'#8D8D8D'}}>{label}</span>
            </button>
        </div>
        </div>
        
    )
}

export default CusAddBtn;